import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';
import {FormGroup} from '@angular/forms';
import {environment} from '../../../environments/environment';

export interface RepositoryInterface<T> {
    getAll(): Observable<T[]>;

    getById(id: number): Observable<T>;

    post(entity: T): Observable<T>;

    put(entity: any, id: number): Observable<T>;

    delete(id: number): Observable<any>;
}

export abstract class AbstractService<T> implements RepositoryInterface<T> {

    private readonly baseUrl: string;

    protected constructor(baseUrl: string, public http: HttpClient) {
        this.baseUrl = baseUrl;
    }

    public getAll(relativeUrl?: string): Observable<T[]> {
        return this.http.get<T[]>(this.getUrl(relativeUrl), this.headers())
            .pipe(map(this.extractListData), catchError(this.handleError));
    }

    public getById(id?: number, relativeUrl?: string): Observable<T> {
        const strId = id ? `${id}` : '';
        let url = `${strId}`;
        if (relativeUrl) {
            url = `${relativeUrl}/${strId}`;
        }
        // @ts-ignore
        return this.http.get<T>(this.getUrl(url), this.headers())
            .pipe(map(this.extractData));
    }

    public getOne(relativeUrl: string): Observable<T> {
        // @ts-ignore
        return this.http.get<T>(this.getUrl(relativeUrl), this.headers())
            .pipe(map(this.extractData), catchError(this.handleError));
    }

    public getBy(param?: any, relativeUrl?: string): Observable<T> {
        // const strParam = param ? `${param}` : '';
        // let url = `${strParam}`;
        // if (relativeUrl) {
        //   url = `${relativeUrl}`;
        // }
        // @ts-ignore
        return this.http.get<T>(this.getUrl(relativeUrl), {headers: this.headers(), params: param})
            .pipe(map(this.extractData), catchError(this.handleError));
    }

    public post(entity: T, relativeUrl?: string): Observable<T> {
        // @ts-ignore
        return this.http.post<T>(this.getUrl(relativeUrl), entity, this.headers())
            .pipe(map(this.extractData), catchError(this.handleError));
    }

    public postFormData(entity: FormData, relativeUrl?: string): Observable<T> {
        // @ts-ignore
        return this.http.post<T>(this.getUrl(relativeUrl), entity)
            .pipe(map(this.extractData), catchError(this.handleError));
    }

    public postFormGroup(entity: FormGroup, relativeUrl?: string): Observable<T> {
        // @ts-ignore
        return this.http.post<T>(this.getUrl(relativeUrl), entity)
            .pipe(map(this.extractData), catchError(this.handleError));
    }

    public put(entity: T, id: number, relativeUrl?: string): Observable<T> {
        const strId = id ? `${id}` : '';
        let url = `${strId}`;
        if (relativeUrl) {
            url = `${relativeUrl}/${strId}`;
        }
        // @ts-ignore
        return this.http.put<T>(this.getUrl(url), entity, this.headers())
            .pipe(map(this.extractData), catchError(this.handleError));
    }

    public delete(id: number): Observable<any> {
        return this.http.delete(this.getUrl(`${id}`), this.headers()).pipe(catchError(this.handleError));
    }

    protected getUrl(relativeUrl?: string): string {
        let absoluteUrl = `${environment.apiUrl}/${this.baseUrl}`;
        if (relativeUrl !== null && relativeUrl !== undefined) {
            absoluteUrl += `/${relativeUrl}`;
        }
        return absoluteUrl;
    }

    public filterByParam(params?: any, relativeUrl?: string): Observable<any[]> {
        return this.http.get<any[]>(this.getUrl(relativeUrl), {params}).pipe(map(this.extractData));
    }

    protected handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        } else {
            console.log(error);
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        return throwError(error.error);
    }

    protected headers() {
        return {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
        };
    }

    protected extractListData(res: any): Array<any> {
        let arrRes = [];
        let body: any = res;
        if (body && body.resposta && body.resposta.length) {
            return body.resposta;
        }
        if (body && body.length) {
            return body;
        }
        return arrRes;
    }

    protected extractData(res: any): any {
        let body: any = res;
        if (body) {
            return body;
        }
        return {};
    }
}
